<template>
  <div>
    <header class="navbar p-1 bg-primary">
      <section class="navbar-section">
        <button
          v-on:click="openSidebar"
          class="btn btn-primary btn-action btn-link show-lg text-light"
          aria-label="Open sidebar"
        >
          <menu-icon />
        </button>
        <span id="header-title" class="navbar-brand mx-2 text-light">
          {{ title }}
        </span>
      </section>
      <section class="navbar-section">
        <span role="toolbar">
          <button
            v-if="outputType"
            v-on:click="ConfigStore.data.config.outputTab = outputType"
            class="btn btn-action btn-link text-light tooltip tooltip-bottom"
            data-tooltip="MATPOWER Output"
            aria-label="Show MATPOWER output dialog"
          >
            <terminal-icon />
          </button>
          <Menu light="true" />
        </span>
      </section>
    </header>
    <error-toast class="my-1" />
    <success-toast class="my-1" />
  </div>
</template>

<script>
import { TerminalIcon, MenuIcon } from "vue-feather-icons";

import Sidebar from "./Sidebar";
import Menu from "./Menu";
import ErrorToast from "./ErrorToast";
import SuccessToast from "./SuccessToast";

import ConfigStore from "../stores/ConfigStore";
import IOStore from "../stores/IOStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";

export default {
  name: "Header",
  props: {
    title: String
  },
  data() {
    return { ConfigStore: ConfigStore };
  },
  computed: {
    outputType() {
      if (IOStore.methods.output()) {
        return "io";
      } else if (PFStore.methods.getOutput()) {
        return "pf";
      } else if (OPFStore.methods.getOutput()) {
        return "opf";
      } else {
        return "";
      }
    }
  },
  methods: {
    openSidebar: Sidebar.methods.openSidebar
  },
  components: {
    Menu,
    ErrorToast,
    SuccessToast,
    TerminalIcon,
    MenuIcon
  }
};
</script>

<style scoped>
header {
  border-radius: 0 0 0.1rem 0.1rem;
}
</style>
